import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView } from "../../../../Component/style/common_style";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";

const WithdrawModal = ({ visible, handleModal }: modalProps) => {
  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const dropUser = () => {
    api
      .delete(url.Communication_url.dropUser, {})
      .then((res) => {
        console.log(res.data);
        if (res.data === "성공") {
          alert("탈퇴 되었습니다.");
          localStorage.removeItem("key");
          localStorage.removeItem("authority");
          window.location.href = "/";
        }
      })
      .catch((error) => {
        console.error("실패:", error);
      });
  };
  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>회원탈퇴</Title>
        <ContentDiv>
          <div>
            회원탈퇴시 계정 정보는 삭제되어 재가입 시 복구가 불가능합니다.
          </div>
          <br />
          <div>정말 탈퇴하시겠습니까?</div>
        </ContentDiv>
        <BtnDiv>
          <CancelBtn onClick={closeModal}>취소하기</CancelBtn>
          <ApplyBtn onClick={dropUser}>탈퇴하기</ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default WithdrawModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 22rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 2rem 1rem 1rem 1rem;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: #8e8e8e;
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  padding: 18px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: #e4e4e4;
  color: #8e8e8e;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;
